var _circle, _circle2, _circle3, _path, _path2, _path3, _polygon, _polygon2, _path4, _path5, _polygon3, _path6, _path7, _path8, _circle4, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _rect3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 562.67538,
    height: 591.73931,
    viewBox: "0 0 562.67538 591.73931",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 182.65265,
    cy: 58,
    r: 58,
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.65265,
    cy: 209,
    r: 58,
    fill: "#f2f2f2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.65265,
    cy: 370,
    r: 58,
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M751.09667,714.68711a3.61324,3.61324,0,0,0,2.61866-6.26263c-.09111-.36212-.15647-.62217-.24758-.98429q.0489-.11823.09837-.23628a9.70311,9.70311,0,0,1,17.89849.06652c2.92739,7.05051,6.65446,14.11307,7.57216,21.56779a28.70521,28.70521,0,0,1-.50391,9.87235,115.086,115.086,0,0,0,10.46894-47.79893,111.07978,111.07978,0,0,0-.689-12.392q-.5708-5.05968-1.58377-10.04731a116.41946,116.41946,0,0,0-23.087-49.34151,30.98262,30.98262,0,0,1-12.88557-13.36893,23.63324,23.63324,0,0,1-2.14932-6.45821c.62728.08228,1.26488.13369,1.89217.17479.19542.01023.40108.02055.5965.03086l.0737.0033a3.57989,3.57989,0,0,0,2.9401-5.83225q-.40627-.5-.81306-.99948c-.41139-.51422-.833-1.01813-1.24433-1.53227a1.78213,1.78213,0,0,1-.1337-.15433c-.47312-.58618-.94608-1.16206-1.41921-1.74824a10.35167,10.35167,0,0,1,3.39367-3.28044c4.74083-2.77662,11.28132-.85358,14.70585,3.43476,3.43477,4.28826,4.0826,10.30438,2.88976,15.66218a41.48466,41.48466,0,0,1-5.73842,12.793c.25716.32912.52455.64792.78162.977a117.172,117.172,0,0,1,12.22972,19.37481,48.70925,48.70925,0,0,1,2.908-22.62446c2.78346-6.71479,8.00064-12.37,12.595-18.175,5.51856-6.9726,16.83488-3.92959,17.80713,4.90927q.0141.12837.02756.25666-1.02362.57749-2.004,1.22585a4.90111,4.90111,0,0,0,1.976,8.91909l.09994.01543a48.76572,48.76572,0,0,1-1.28543,7.29124,50.20985,50.20985,0,0,1-24.99984,31.46836c-.40108.20566-.79192.41132-1.193.60674a119.59737,119.59737,0,0,1,6.43766,30.296,113.433,113.433,0,0,1-.08228,18.31542l.03087-.216a29.974,29.974,0,0,1,10.23241-17.30759c7.87437-6.46853,18.99939-8.8505,27.49445-14.04994a5.62529,5.62529,0,0,1,8.61572,5.47252q-.01708.1135-.03475.227a32.92361,32.92361,0,0,0-3.69183,1.779q-1.02363.5776-2.004,1.22585a4.90115,4.90115,0,0,0,1.976,8.91916l.1.01535c.072.01032.1337.02063.20558.03095a48.808,48.808,0,0,1-8.97768,14.05786,50.25439,50.25439,0,0,1-36.44572,15.99129H788.539a119.56291,119.56291,0,0,1-8.03168,23.447H751.81564c-.10291-.31881-.19542-.64792-.288-.96672a32.59917,32.59917,0,0,0,7.93915-.473c-2.12877-2.61214-4.25747-5.24483-6.38625-7.85688a1.783,1.783,0,0,1-.13369-.15425c-1.07978-1.33685-2.16988-2.66346-3.24966-4.00032l-.00058-.00165a47.75114,47.75114,0,0,1,1.39916-12.16411Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M526.5965,374.68848a9.86069,9.86069,0,0,0,13.887,5.98126l25.47578,23.24959,3.38253-17.89268L544.61509,366.749a9.91422,9.91422,0,0,0-18.01859,7.93946Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#ffb6b6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M615.26671,356.91723s8.88322-20.075,20.10283-16.08459c10.305,3.66508,11.67464,2.46039,5.42667,23.46842L598.64389,427.819s-44.335-28.17686-36.94184-28.45236,7.19294-14.38586,7.19294-14.38586l18.081,5.89456,1.08724-5.71572,1.74262,1.74263,4.49687-3.53941Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#e363ff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "330.231 254.446 328.357 271.827 329.46 294.62 281.653 289 278.231 254.446 284.275 254.505 330.231 254.446",
    fill: "#ffb6b6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.417 570.02 328.379 570.02 317.653 487 342.653 487 339.417 570.02",
    fill: "#ffb6b6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M678.29134,652.9692v17.98s-15.9,14.23-27,1l-6.92-58.62s-.17-5.49-3.6-8.75a4.67281,4.67281,0,0,1-.76-.94c-2.48-3.83-1.47-11.75-1.47-11.75s-4.82-2.6-6.34-11c-1.52-8.4-6.52-26.75-6.52-26.75s-10.33-27.09-9.61-44.24c.12994-3.17005.18-6.06.18-8.66-.03-11.48-1.18-17.41-1.18-17.41l-2.09-39.84,4.31-6.04,19.71.58,1.34-.04.49-.01,20.24-.61,11.43,6.72s1.02,2.54,2.46,6.05c2.69,6.51,6.83,16.36,8.66,19.67,2.82,5.1,1.42,31.34-8.18,43,0,0-3.99,5.67-2.94,7.72.95,1.86005.04,5.01-.14,5.57v.01c-.02.05-.03.08-.03.08l-1.53,34s0,14.57,3.43,19.89S678.29134,652.9692,678.29134,652.9692Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M680.88145,739.093h-7.91553l-1.41289-7.4732-3.61861,7.4732H646.94053a4.71924,4.71924,0,0,1-2.68162-8.60273L661.024,718.91173v-7.55515l17.634,1.05251Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "274.158 570.237 263.293 568.29 267.384 484.68 291.992 489.091 274.158 570.237",
    fill: "#ffb6b6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M673.44136,513.30923s-3.99,5.67-2.94,7.72c.95,1.86005.04,5.01-.14,5.57v.01a27.72424,27.72424,0,0,1-3.49,2.35s-5.78,3.84-5.54,6.13c.23,2.29-2.22,5.21-2.22,5.21l-13.77,31.12s-5.3,13.58-4.03,19.78c.38995,1.9-.24,6.69-1.30005,12.44-2.37,13.02-10.94995,58.91-10.94995,58.91l-6.77,16.4s-25.33-7.03-26-9c0,0,9-63.54,6.99-67.82-2.01-4.28-1.02-16.81.62-25.18,1.63-8.38,3.86-56.29,10.76-72,.56-1.28,1.09-2.52,1.59-3.71,5.57-13.41,6.95-20.95,6.95-20.95l12.52-37.87,1.28-3.89.29,1.42,1.54-1.47,22.52,8.02,11.61,4.14c2.69,6.51,6.83,16.36,8.66,19.67C684.44136,475.40921,683.04134,501.64926,673.44136,513.30923Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M611.466,712.60148l-12.123-2.92343-1.84018-.44294-1.32858,7.4367-18.54877,8.44174a4.7105,4.7105,0,0,0,1.12619,8.93063l20.6556,3.71018,4.884-6.71994.07113,7.6096,7.79538,1.39048L614.6761,713.376Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M897.12339,741.68855h-560.294a1.19069,1.19069,0,0,1,0-2.38137h560.294a1.19069,1.19069,0,0,1,0,2.38137Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#ccc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.89131,
    cy: 155.16253,
    r: 22.04789,
    fill: "#ffb7b7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M621.9122,347.2701l11.99626-7.19776,5.38288-9.1231h14l4.60965,6.72385,21.206,10.79851-.21254,32.98785-9.6031,49.48979-55-16-3.37447-18.5417s-19.59514-20.94622-2.80037-32.94249Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#e363ff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M673.26311,489.7005a9.15745,9.15745,0,0,0,2.03056-13.89428l7.736-83.04692-19.85557,1.53354-1.3607,81.15019a9.20709,9.20709,0,0,0,11.44976,14.25747Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#ffb6b6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M679.29134,347.94924s0,1,3.31256,10.38755c2.83771,8.04184,7.86005,57.44613-1.93909,69.50387,2.73236,1.68332-1.37648,32.90291-2.37347,36.10858l-20-5c-2.69785-4.6372.17421-37.18539,2.135-37.95714l-.11518-14.82014L655.193,357.32127l19.70961-8.07387Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#e363ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M537.906,387.25143l-5.04427-32.32911a4.227,4.227,0,0,1,3.521-4.82284l7.04594-1.09937a4.227,4.227,0,0,1,4.82284,3.521l5.04427,32.3291a4.227,4.227,0,0,1-3.521,4.82285l-7.04594,1.09937A4.227,4.227,0,0,1,537.906,387.25143Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M537.46442,351.61974a2.278,2.278,0,0,0-1.8974,2.599l5.04427,32.32911a2.278,2.278,0,0,0,2.599,1.8974l7.04594-1.09937a2.278,2.278,0,0,0,1.8974-2.599l-5.04427-32.32911a2.278,2.278,0,0,0-2.599-1.89741Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#e363ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M677.29134,315.23992v2.47153A11.94826,11.94826,0,0,1,665.03873,329.659l-16.23863-.51534a11.40318,11.40318,0,0,0-1.55653-4.54345,10.71667,10.71667,0,0,1-.631,4.49088l-7.18329-.17878c5.69513-12.551,7.91643-23.22006,0-28.39655H628.78583a11.44554,11.44554,0,0,0-1.525-4.31211,10.55446,10.55446,0,0,1-.5679,4.31211H616.29134A19.98737,19.98737,0,0,1,636.2741,280.533h3.15517C663.21926,274.54871,675.77685,287.33765,677.29134,315.23992Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M435.22765,383.39135a12.60849,12.60849,0,1,1,12.60849-12.60849A12.62276,12.62276,0,0,1,435.22765,383.39135Zm0-22.92453a10.316,10.316,0,1,0,10.316,10.316A10.328,10.328,0,0,0,435.22765,360.46682Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M435.22765,388.54937a17.76651,17.76651,0,1,1,17.76651-17.76651A17.78642,17.78642,0,0,1,435.22765,388.54937Zm0-33.24057a15.47406,15.47406,0,1,0,15.47405,15.47406A15.4917,15.4917,0,0,0,435.22765,355.3088Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M435.22765,408.03522A37.25237,37.25237,0,1,1,472.48,370.78286,37.29477,37.29477,0,0,1,435.22765,408.03522Zm0-72.21227a34.95991,34.95991,0,1,0,34.95991,34.95991A34.99934,34.99934,0,0,0,435.22765,335.823Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 410.90677,
    y: 349.5389,
    width: 2.29233,
    height: 28.64757,
    transform: "translate(-464.59537 116.48519) rotate(-31.23732)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 425.95718,
    y: 394.03768,
    width: 26.84772,
    height: 2.29286,
    transform: "translate(-455.97098 434.83223) rotate(-60.68186)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 438.84739,
    y: 353.21492,
    width: 28.44296,
    height: 2.29268,
    transform: "translate(-340.61058 -143.49884) rotate(-0.81126)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M479.32365,502.76622l-1.2309-1.93372a19.43494,19.43494,0,0,1,10.2644-3.03648l.022,2.29235A17.14939,17.14939,0,0,0,479.32365,502.76622Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M490.04273,553.94753a36.68047,36.68047,0,0,1-23.44855-65.17374l1.44435,1.78055a34.38617,34.38617,0,1,0,48.5307,5.26586l1.79075-1.431a36.31277,36.31277,0,0,1,8.008,22.52853A36.72056,36.72056,0,0,1,490.04273,553.94753Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M474.99638,520.115l-2.19915-.64828a8.81742,8.81742,0,0,1,6.32094-6.15872l.1845-.02192,6.86953-.26523,2.63392-3.21115-2.02514-.65331-9.847-7.23871-.073-7.60068-10.24952,6.97612-.11084-11.54121,2.29235-.022.0697,7.25761,10.24951-6.97611.10313,10.7381,8.62384,6.33925,4.87392,1.573-5.4222,6.6096-7.78991.30094A6.5416,6.5416,0,0,0,474.99638,520.115Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M521.80281,509.78219l-21.51908-30.308c-10.84515,2.76949-11.24981,19.3211-11.25265,19.49184l-2.2918-.03844c.01315-.78707.47561-19.30381,13.823-21.86337l.72349-.139L516.937,498.9695l-1.07487-4.628,2.23273-.51846Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M489.2825,534.46808a16.72152,16.72152,0,0,1-16.70129-14.99758l2.28148-.22117a14.32835,14.32835,0,0,0,28.58736-1.53837,14.23516,14.23516,0,0,0-7.01993-12.189l-5.04206-2.99582,9.91449,1.49938a18.12546,18.12546,0,0,0-12.8691-3.93875l-.13057-2.28907c11.49674-.66117,16.89489,6.89172,17.11906,7.21308l1.51933,2.18562-5.83782-.88256a16.63129,16.63129,0,0,1-11.82095,28.15428Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M519.269,200.43c-.18344-.18336-.35533-.35532-.53877-.53869a36.66528,36.66528,0,0,0-51.82086,51.87823c.16049.17189.33239.34385.50435.51581A36.66855,36.66855,0,0,0,519.269,200.43Zm-26.1569,60.08525a34.23339,34.23339,0,0,1-23.73838-9.53661c-.38968-.3668-.768-.74508-1.12328-1.13475a34.358,34.358,0,0,1,48.56562-48.58857q.58461.55022,1.13475,1.13476a34.35707,34.35707,0,0,1-24.83871,58.12517Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M518.73022,199.89135l-1.91417,1.364-28.03673,19.86413-1.07739.75648-19.4515,27.968-1.34107,1.92565c.16049.17189.33239.34385.50435.51581l1.96-1.30671,28.03673-18.695,1.1118-.74508,19.42856-29.14853L519.269,200.43C519.08555,200.24668,518.91366,200.07472,518.73022,199.89135Zm-21.26249,29.10271-.596.894-1.05457.69925L474.57762,244.7432l14.15587-20.34552.61894-.89409,1.02016-.72213,21.274-15.06136Z",
    transform: "translate(-335.63869 -149.94924)",
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 491.96584,
    y: 220.60933,
    width: 2.2925,
    height: 12.18456,
    transform: "matrix(0.6585, -0.75258, 0.75258, 0.6585, -337.85353, 298.57298)",
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 155.75406,
    y: 43.51179,
    width: 2.29245,
    height: 5.37014,
    fill: "#2f2e41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 155.75406,
    y: 101.96935,
    width: 2.29245,
    height: 5.37014,
    fill: "#2f2e41"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 155.75406,
    y: 43.51179,
    width: 2.29245,
    height: 5.37014
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 155.75406,
    y: 101.96935,
    width: 2.29245,
    height: 5.37014
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 500.70862,
    y: 197.09017,
    width: 5.37017,
    height: 2.2927,
    transform: "translate(-203.11587 442.18792) rotate(-68.21937)",
    fill: "#2f2e41"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 478.99916,
    y: 251.3669,
    width: 5.37017,
    height: 2.2927,
    transform: "translate(-267.17195 456.16541) rotate(-68.21937)",
    fill: "#2f2e41"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 500.70862,
    y: 197.09017,
    width: 5.37017,
    height: 2.2927,
    transform: "translate(-203.11587 442.18792) rotate(-68.21937)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 478.99916,
    y: 251.3669,
    width: 5.37017,
    height: 2.2927,
    transform: "translate(-267.17195 456.16541) rotate(-68.21937)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 507.1511,
    y: 200.66743,
    width: 5.37019,
    height: 2.29257,
    transform: "translate(-290.19015 343.42206) rotate(-53.71759)",
    fill: "#2f2e41"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 472.55666,
    y: 247.78977,
    width: 5.37019,
    height: 2.29257,
    transform: "translate(-342.29857 334.77209) rotate(-53.71759)",
    fill: "#2f2e41"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 507.1511,
    y: 200.66743,
    width: 5.37019,
    height: 2.29257,
    transform: "translate(-290.19015 343.42206) rotate(-53.71759)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 472.55666,
    y: 247.78977,
    width: 5.37019,
    height: 2.29257,
    transform: "translate(-342.29857 334.77209) rotate(-53.71759)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 514.17178,
    y: 208.01249,
    width: 5.3701,
    height: 2.2924,
    transform: "translate(-364.8531 171.87948) rotate(-33.69007)",
    fill: "#2f2e41"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 465.53607,
    y: 240.44488,
    width: 5.3701,
    height: 2.2924,
    transform: "translate(-391.01171 150.34825) rotate(-33.69007)",
    fill: "#2f2e41"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 514.17178,
    y: 208.01249,
    width: 5.3701,
    height: 2.2924,
    transform: "translate(-364.8531 171.87948) rotate(-33.69007)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 465.53607,
    y: 240.44488,
    width: 5.3701,
    height: 2.2924,
    transform: "translate(-391.01171 150.34825) rotate(-33.69007)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 517.64583,
    y: 215.17771,
    width: 5.37044,
    height: 2.29203,
    transform: "translate(-377.0483 21.78993) rotate(-18.03676)",
    fill: "#2f2e41"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 462.06168,
    y: 233.28003,
    width: 5.37044,
    height: 2.29203,
    transform: "matrix(0.95086, -0.30963, 0.30963, 0.95086, -385.38478, 5.46915)",
    fill: "#2f2e41"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 517.64583,
    y: 215.17771,
    width: 5.37044,
    height: 2.29203,
    transform: "translate(-377.0483 21.78993) rotate(-18.03676)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 462.06168,
    y: 233.28003,
    width: 5.37044,
    height: 2.29203,
    transform: "matrix(0.95086, -0.30963, 0.30963, 0.95086, -385.38478, 5.46915)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 519.07744,
    y: 223.67297,
    width: 5.36999,
    height: 2.29287,
    transform: "translate(-339.82456 -139.97439) rotate(-1.09095)",
    fill: "#2f2e41"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 460.63052,
    y: 224.78393,
    width: 5.36999,
    height: 2.29287,
    transform: "translate(-339.85631 -141.08699) rotate(-1.09095)",
    fill: "#2f2e41"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 519.07744,
    y: 223.67297,
    width: 5.36999,
    height: 2.29287,
    transform: "translate(-339.82456 -139.97439) rotate(-1.09095)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 460.63052,
    y: 224.78393,
    width: 5.36999,
    height: 2.29287,
    transform: "translate(-339.85631 -141.08699) rotate(-1.09095)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 519.89341,
    y: 229.17401,
    width: 2.2924,
    height: 5.37011,
    transform: "translate(-156.24179 538.55099) rotate(-77.18621)",
    fill: "#2f2e41"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 462.89214,
    y: 216.20564,
    width: 2.2924,
    height: 5.37011,
    transform: "translate(-187.95573 472.87709) rotate(-77.18621)",
    fill: "#2f2e41"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 519.89341,
    y: 229.17401,
    width: 2.2924,
    height: 5.37011,
    transform: "translate(-156.24179 538.55099) rotate(-77.18621)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 462.89214,
    y: 216.20564,
    width: 2.2924,
    height: 5.37011,
    transform: "translate(-187.95573 472.87709) rotate(-77.18621)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 517.41042,
    y: 236.0094,
    width: 2.29232,
    height: 5.37011,
    transform: "translate(-265.84095 441.57869) rotate(-62.89283)",
    fill: "#2f2e41"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 465.37521,
    y: 209.37026,
    width: 2.29232,
    height: 5.37011,
    transform: "translate(-270.45301 380.7584) rotate(-62.89283)",
    fill: "#2f2e41"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 517.41042,
    y: 236.0094,
    width: 2.29232,
    height: 5.37011,
    transform: "translate(-265.84095 441.57869) rotate(-62.89283)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 465.37521,
    y: 209.37026,
    width: 2.29232,
    height: 5.37011,
    transform: "translate(-270.45301 380.7584) rotate(-62.89283)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 513.71402,
    y: 241.55982,
    width: 2.29231,
    height: 5.37053,
    transform: "translate(-339.69664 329.79666) rotate(-49.78924)",
    fill: "#2f2e41"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 469.07162,
    y: 203.81941,
    width: 2.29231,
    height: 5.37053,
    transform: "translate(-326.69646 282.32923) rotate(-49.78924)",
    fill: "#2f2e41"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 513.71402,
    y: 241.55982,
    width: 2.29231,
    height: 5.37053,
    transform: "translate(-339.69664 329.79666) rotate(-49.78924)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 469.07162,
    y: 203.81941,
    width: 2.29231,
    height: 5.37053,
    transform: "translate(-326.69646 282.32923) rotate(-49.78924)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 509.15473,
    y: 245.90246,
    width: 2.29255,
    height: 5.36983,
    transform: "translate(-381.67629 211.28868) rotate(-37.41931)",
    fill: "#2f2e41"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 473.63066,
    y: 199.47748,
    width: 2.29255,
    height: 5.36983,
    transform: "translate(-360.77696 180.14891) rotate(-37.41931)",
    fill: "#2f2e41"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 509.15473,
    y: 245.90246,
    width: 2.29255,
    height: 5.36983,
    transform: "translate(-381.67629 211.28868) rotate(-37.41931)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 473.63066,
    y: 199.47748,
    width: 2.29255,
    height: 5.36983,
    transform: "translate(-360.77696 180.14891) rotate(-37.41931)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 503.83646,
    y: 249.13725,
    width: 2.29237,
    height: 5.37015,
    transform: "translate(-394.7982 89.00522) rotate(-25.19763)",
    fill: "#2f2e41"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 478.94912,
    y: 196.24237,
    width: 2.29237,
    height: 5.37015,
    transform: "translate(-374.6468 73.37641) rotate(-25.19763)",
    fill: "#2f2e41"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 503.83646,
    y: 249.13725,
    width: 2.29237,
    height: 5.37015,
    transform: "translate(-394.7982 89.00522) rotate(-25.19763)"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 478.94912,
    y: 196.24237,
    width: 2.29237,
    height: 5.37015,
    transform: "translate(-374.6468 73.37641) rotate(-25.19763)"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 497.43162,
    y: 251.28813,
    width: 2.29263,
    height: 5.3701,
    transform: "translate(-377.3481 -41.4818) rotate(-11.92126)",
    fill: "#2f2e41"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 485.3537,
    y: 194.09153,
    width: 2.29263,
    height: 5.3701,
    transform: "translate(-365.79365 -45.21029) rotate(-11.92126)",
    fill: "#2f2e41"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 497.43162,
    y: 251.28813,
    width: 2.29263,
    height: 5.3701,
    transform: "translate(-377.3481 -41.4818) rotate(-11.92126)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 485.3537,
    y: 194.09153,
    width: 2.29263,
    height: 5.3701,
    transform: "translate(-365.79365 -45.21029) rotate(-11.92126)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 484.28202,
    y: 252.92155,
    width: 5.3701,
    height: 2.29188,
    transform: "translate(-190.84378 533.77558) rotate(-79.01935)",
    fill: "#2f2e41"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 495.42583,
    y: 195.53634,
    width: 5.3701,
    height: 2.29188,
    transform: "translate(-125.48804 498.26074) rotate(-79.01935)",
    fill: "#2f2e41"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 484.28202,
    y: 252.92155,
    width: 5.3701,
    height: 2.29188,
    transform: "translate(-190.84378 533.77558) rotate(-79.01935)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 495.42583,
    y: 195.53634,
    width: 5.3701,
    height: 2.29188,
    transform: "translate(-125.48804 498.26074) rotate(-79.01935)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/svg-3.61a92f51b2536943eab5525cecd8688c.svg";
export { ForwardRef as ReactComponent };